var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "nav-bar-container" }, [
      _c("div", { staticClass: "nav-bar" }, [
        _c("span", { staticClass: "summary-hello" }, [
          _vm._v(_vm._s(_vm.$t("hello"))),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "summary-name" }, [
          _vm._v(
            _vm._s(
              (_vm.currentUserContact || {}).name || _vm.currentUser.name
            ) + ","
          ),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "summary-hello" }, [
          _vm._v(_vm._s(_vm.$t("welcome"))),
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("label", { staticClass: "summary-hello emphasis" }, [
          _vm._v(_vm._s(_vm.$t("settings.title"))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "vendor-detail-container" },
      [
        _c("vendor-detail", {
          attrs: { contactId: _vm.deep(_vm.currentUserContact, "id") },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }